import { openPopup } from '../../../../../individual-restaurants/library/src/js/functions/popups'; 
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";


export const urlParams = () => {

	// Check to see if we're using any custom URL params on load (after a timeout so allow 3rd parties to load)
	setTimeout(() => {
		handleURLParamsFunctionality(window.location.href);
	},750);
	

	let allATags = document.querySelectorAll('a');
	allATags.forEach((aTag) => { //Loop through each and give it a onclick event listener

		let linkHref = aTag.getAttribute('href');
		if(linkHref){
			if (linkHref.indexOf("#") != -1) {
				aTag.addEventListener('click', (event) => {
					event.preventDefault();
					let targetEl = event.target.getAttribute('href');
					if(targetEl == null){
						targetEl = event.target.parentElement.getAttribute('href');
					}

					handleURLParamsFunctionality(targetEl);
					return false;
				});
			}
		}		
	});


}




function handleURLParamsFunctionality(href){
	
	//#scrollTo:ElementIDToScrollTo  |   Will either load the page and scroll to that element ID, or scroll on click
	//#book:LocationName     		 |   Will trigger the resevations popup. Add a location name to preselect that location
	//#popup:PopupID				 |   Will open a specific popup.
	

	if (href.indexOf("#") != -1) { //Check if the link has a #
		let hashRaw = href.split('#')[1],
			hashValue = hashRaw.split(':');
		const bookingLocations = JSON.parse(document.querySelector('.popup__ot-booking-location').getAttribute('data-booking-locations'));
		let blogID;

		switch (hashValue[1]) {
			case 'piccolino':
				blogID = 3;
				break;
			case 'rivablu':
				blogID = 2;
				break;
			case 'rbg':
				blogID = 4;
				break;
			case 'piccolo':
				blogID = 5;
				break;
		}			

		if(hashValue[0] == 'book'){	

			document.querySelector('#reservations').classList.remove('private-dining'); //Remove class hiding the OT widget

			//Preselect the venue if passed through as the 2nd value
			let dmnVenueContainer 	= document.querySelector('.dmn-form .dmn-venue-container')
				dmnVenueSelect 		= document.querySelector('#dmn-venue'),
                dmnOptions          = dmnVenueSelect.querySelectorAll('option'),
				dmnExtraFields 		= document.querySelector('.dmn-form .main-inputs'),
				otWidget 			= document.querySelector('.popup__ot-booking');
				otSelect 			= document.querySelector('.ot-select');

			// Uncomment for OT go live
			if(dmnVenueContainer && dmnVenueSelect && dmnExtraFields && otWidget){

			//if(dmnVenueContainer && dmnVenueSelect && dmnExtraFields && otSelect){

				if(hashValue[1]){ //Brand has been passed through
                    // Open Table brand filtering


                    // if ( bookingLocations[blogID] ) {
                    //     const updatedChoices = [{value: '0', label: 'Please choose a location', selected: true, disabled: true}];

                    //     bookingLocations[blogID].forEach(loc => {
                    //         const choice = {
                    //             value: loc.ot_key,
                    //             label: loc.label
                    //         };

                    //         updatedChoices.push(choice);
                    //     });

                    //     window.otSelectChoices.setChoices(updatedChoices, 'value', 'label', true);
                    // }


                    // Uncomment for OT go live
              		let selectElement = document.getElementById('restaurant_rid');
		            let options = selectElement.getElementsByTagName('option');
		            const lowerCaseBrand = hashValue[1].toLowerCase();

		            for (let i = 0; i < options.length; i++) {
		            	if(options[i].value !== "") {
			                const optionBrand = options[i].getAttribute('data-brand').toLowerCase();
			                if (optionBrand !== lowerCaseBrand && options[i].value !== "") {
			                    options[i].style.display = 'none';
			                }
			            }
		            }

                    // DMN brand filtering
                    if ( bookingLocations[blogID] ) {
                        const dmnVals = [];

                        bookingLocations[blogID].forEach(loc => {
                            dmnVals.push(loc.dmn_index);
                        });

                        if (dmnOptions) {
                            // Show all the options again before filtering
                            dmnOptions.forEach(option => {
                                option.classList.remove('hidden');
                            });

                            dmnOptions.forEach(option => {
                                const val = option.getAttribute('value');
                                let optionAllowed = false;

                                if ( val && dmnVals.includes(parseInt(val)) ) {
                                    optionAllowed = true;
                                }

                                if ( !optionAllowed ) {
                                    option.classList.add('hidden');
                                }
                            });
                        }
                    }
				} else {
					//Add additional styles to the default DMN widget
                    dmnOptions.forEach(option => {
                        option.classList.remove('hidden');
                    });
					dmnVenueSelect.value = null;
					dmnVenueContainer.classList.remove('venue-selected');
					dmnExtraFields.classList.add('invisible');

					// window.otSelectChoices.destroy();
					// otSelect.value = null;
     //                window.otSelectChoices.init();
					// window.otSelectChoices.setChoiceByValue("0");

					// Uncomment for OT go live
              		let selectElement = document.getElementById('restaurant_rid');
		            let options = selectElement.getElementsByTagName('option');

		            for (let i = 0; i < options.length; i++) {
		                options[i].style.display = 'block';
		            }
				}
			}
		
			openPopup('#reservations');

		}else if(hashValue[0] == 'enquire'){	

			document.querySelector('#reservations').classList.add('private-dining'); //Add class so we can hide the OT widget

			//Preselect the venue if passed through as the 2nd value
			let dmnVenueContainer 	= document.querySelector('.dmn-form .dmn-venue-container')
				dmnVenueSelect 		= document.querySelector('#dmn-venue'),
				dmnOptions          = dmnVenueSelect.querySelectorAll('option'),
				dmnExtraFields 		= document.querySelector('.dmn-form .main-inputs'),
				otSelect 			= document.querySelector('.ot-select');

			if(dmnVenueContainer && dmnVenueSelect && dmnExtraFields && otSelect){

				if ( hashValue[1] ) { //Location has been passed through
					// DMN brand filtering
					if ( bookingLocations[blogID] ) {
						const dmnVals = [];

						bookingLocations[blogID].forEach(loc => {
							dmnVals.push(loc.dmn_index);
						});

						if (dmnOptions) {
							// Show all the options again before filtering
							dmnOptions.forEach(option => {
								option.classList.remove('hidden');
							});

							dmnOptions.forEach(option => {
								const val = option.getAttribute('value');
								let optionAllowed = false;

								if ( val && dmnVals.includes(parseInt(val)) ) {
									optionAllowed = true;
								}

								if ( !optionAllowed ) {
									option.classList.add('hidden');
								}
							});
						}
					}
				} else {
					//Add additional styles to the default DMN widget
                    dmnOptions.forEach(option => {
                        option.classList.remove('hidden');
                    });
					dmnVenueSelect.value = null;
					dmnVenueContainer.classList.remove('venue-selected');
					dmnExtraFields.classList.add('invisible');

					otSelect.value = null;
					window.otSelectChoices.setChoiceByValue("0");
				}


			}

			openPopup('#reservations');

		}else if(hashValue[0] == 'scrollTo'){	
			//Scroll to the element!
			let elementToScrollTo = document.querySelector('#' + hashValue[1]);
			if(elementToScrollTo){
				
				locationPageSubnavs = document.querySelectorAll(".m__lsubnav");
				if(locationPageSubnavs){
					document.querySelector("#js__body").classList.remove('js__popup-active');
					locationPageSubnavs.forEach((subnav) => {
						subnav.classList.remove('open');
					});
				}
				gsap.registerPlugin(ScrollToPlugin);
				gsap.to(window, {duration: 1, scrollTo: elementToScrollTo});
			}
		}else if(hashValue[0] == 'popup'){

			if(hashValue[1] == 'newsletter') {
				const newsletterEmail = document.getElementById('newsletter-email').value;
		        const form = document.getElementById('newsletter-signup-form');
 				const emailAddressInput = form.querySelector('input[name="email_address"]');
        		emailAddressInput.value = newsletterEmail;
			}
			
			if(hashValue[1] != null && hashValue[1] > ''){
				openPopup('#'+hashValue[1]);
			}
		}else{
			return false;
		}
	}
}